import { render } from "./GridSystem.md?vue&type=template&id=1ca6f198"
const script = {}
script.render = render

export default script